// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-con {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.35);
    backdrop-filter: blur(6px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.settings-panel {
    width: 750px;
    height: 500px;
    background: #ffffff;
    border-radius: 16px;
    display: flex;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

/* Left menu */
.settings-menu {
    width: 220px;
    background: #f9fafb;
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-right: 1px solid #eee;
}

.settings-item {
    padding: 12px 16px;
    cursor: pointer;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
}

.settings-item:hover {
    background: #e5e7eb;
}

.settings-item.active {
    background:var(--selecte-row-color);
    color: white;
}

/* Right content */
.settings-content {
    flex: 1 1;
    padding: 30px;
}

.settings-content h3 {
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
}

/* Color grid */
.color-grid {
    display: grid;
    grid-template-columns: repeat(3, 60px);
    gap: 20px;
}

.color-box {
    width: 60px;
    height: 60px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.color-box:hover {
    transform: scale(1.1);
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.2);
}


.color-wrapper {
    position: relative;
    padding-top: 50px;
}

/* Top Left Buttons */
.top-actions {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    gap: 10px;
}

.icon-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    border: none;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.icon-btn:hover {
    background: #e5e7eb;
    transform: scale(1.05);
}

/* Color Grid */
.color-grid {
    display: grid;
    grid-template-columns: repeat(3, 70px);
    gap: 20px;
}

.color-box {
    width: 70px;
    height: 70px;
    border-radius: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.color-box:hover {
    transform: scale(1.08);
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.15);
}

.color-box.selected {
    outline: 3px solid #333;
}


.icon-btn.close{
    border: 2px solid var(--selecte-row-color);
    color: black;
    margin: 5px;
}`, "",{"version":3,"sources":["webpack://./src/view/settings/settings.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,+BAA+B;IAC/B,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA,cAAc;AACd;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,sCAAsC;IACtC,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yCAAyC;AAC7C;;;AAGA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,eAAe;AACf;IACI,aAAa;IACb,sCAAsC;IACtC,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,0CAA0C;IAC1C,YAAY;IACZ,WAAW;AACf","sourcesContent":[".settings-con {\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.35);\n    backdrop-filter: blur(6px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.settings-panel {\n    width: 750px;\n    height: 500px;\n    background: #ffffff;\n    border-radius: 16px;\n    display: flex;\n    overflow: hidden;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n/* Left menu */\n.settings-menu {\n    width: 220px;\n    background: #f9fafb;\n    padding: 20px 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    border-right: 1px solid #eee;\n}\n\n.settings-item {\n    padding: 12px 16px;\n    cursor: pointer;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.2s ease;\n}\n\n.settings-item:hover {\n    background: #e5e7eb;\n}\n\n.settings-item.active {\n    background:var(--selecte-row-color);\n    color: white;\n}\n\n/* Right content */\n.settings-content {\n    flex: 1;\n    padding: 30px;\n}\n\n.settings-content h3 {\n    margin-bottom: 20px;\n    font-size: 18px;\n    font-weight: 600;\n}\n\n/* Color grid */\n.color-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 60px);\n    gap: 20px;\n}\n\n.color-box {\n    width: 60px;\n    height: 60px;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.color-box:hover {\n    transform: scale(1.1);\n    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.2);\n}\n\n\n.color-wrapper {\n    position: relative;\n    padding-top: 50px;\n}\n\n/* Top Left Buttons */\n.top-actions {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    gap: 10px;\n}\n\n.icon-btn {\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    border: none;\n    background: #f3f4f6;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.icon-btn:hover {\n    background: #e5e7eb;\n    transform: scale(1.05);\n}\n\n/* Color Grid */\n.color-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 70px);\n    gap: 20px;\n}\n\n.color-box {\n    width: 70px;\n    height: 70px;\n    border-radius: 14px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.color-box:hover {\n    transform: scale(1.08);\n    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.15);\n}\n\n.color-box.selected {\n    outline: 3px solid #333;\n}\n\n\n.icon-btn.close{\n    border: 2px solid var(--selecte-row-color);\n    color: black;\n    margin: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
